
function transformer(value, params, _next) {
    if(params){
        return eval(`(function(){${params}})(value, _next)`);
    }else{
        return value;
    }
}

export {transformer}